import type {
    ChangelogRelease,
    FeedbackItem,
    RoadmapItem,
} from './types';

export const MOCK_FEEDBACK: FeedbackItem[] = [
    {
        id: 'wf-1',
        title: 'Dark mode for the dashboard',
        description:
            'A system-wide dark theme for the dashboard and boards, with sensible defaults and a quick toggle in the header.',
        votesCount: 42,
        type: 'feature_request',
        voted: true,
    },
    {
        id: 'wf-2',
        title: 'Widget safe area on mobile Safari',
        description:
            'The embed panel overlaps the home indicator on iOS Safari. Needs extra bottom padding when position is bottom-right.',
        votesCount: 31,
        type: 'bug',
        voted: false,
    },
    {
        id: 'wf-3',
        title: 'Export feedback to CSV',
        description:
            'Let project admins export filtered feedback with votes and status for reporting.',
        votesCount: 19,
        type: 'improvement',
        voted: false,
    },
    {
        id: 'wf-4',
        title: 'Slack notifications on ship',
        description:
            'Post to a Slack channel when a roadmap item moves to Shipped or a changelog entry is published.',
        votesCount: 24,
        type: 'feature_request',
        voted: false,
    },
];

export const MOCK_ROADMAP: RoadmapItem[] = [
    {
        id: 'wr-1',
        title: 'Dark mode for the dashboard',
        column: 'in_progress',
        votesCount: 42,
    },
    {
        id: 'wr-2',
        title: 'Bulk status updates',
        column: 'planned',
        votesCount: 19,
    },
    {
        id: 'wr-3',
        title: 'Changelog RSS feed',
        column: 'shipped',
        votesCount: 56,
    },
    {
        id: 'wr-4',
        title: 'Roadmap vote sync fix',
        column: 'shipped',
        votesCount: 17,
    },
];

export const MOCK_CHANGELOG: ChangelogRelease[] = [
    {
        version: '2.3.2',
        title: 'Widget & roadmap fixes',
        date: 'May 1, 2026',
        entries: [
            { type: 'fixed', title: 'Roadmap vote count desync' },
            { type: 'improved', title: 'Mobile Safari widget safe area' },
        ],
    },
    {
        version: '2.3.1',
        title: null,
        date: 'Apr 28, 2026',
        entries: [
            { type: 'new', title: 'Changelog RSS feed' },
            { type: 'improved', title: 'Inertia progress-only loading' },
        ],
    },
];
